import { useRPC } from "../../../hooks/useRPC/index.js";
import { RPCs } from "@therms/rpc-gateway";
//#region src/modules/Locations/hooks/useLocationLogEntryTypes.ts
function useLocationLogEntryTypes(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationLogEntryTypesList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: opts.fire || !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationLogEntryTypes };

//# sourceMappingURL=useLocationLogEntryTypes.js.map